import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../../index";
import { DataStatus } from "../../types";

export const getStationVehicles = (state: RootState) =>
  state.stationConfirmation.data;

const getStationVehiclesStatus = (state: RootState) =>
  state.stationConfirmation.status;

export const getIsStationVehiclesLoaded = createSelector(
  getStationVehiclesStatus,
  (status) => status === DataStatus.succeeded
);
export const getIsStationVehiclesLoadingError = createSelector(
  getStationVehiclesStatus,
  (status) => status === DataStatus.failed
);

export const getIsStationEmpty = createSelector(
  getStationVehicles,
  getStationVehiclesStatus,
  (stations, status) => stations.length === 0 && status === DataStatus.succeeded
);

export const getMissionsInQueue = (station: RootState) =>
  station.stationConfirmation.missionsQueue;

const getMissionsInQueueStatus = (state: RootState) =>
  state.stationConfirmation.missionQueueStatus;

export const getIsMissionsInQueueLoaded = createSelector(
  getMissionsInQueueStatus,
  (status) => status === DataStatus.succeeded
);
export const getIsMissionsInQueueLoadingError = createSelector(
  getMissionsInQueueStatus,
  (status) => status === DataStatus.failed
);
export const getIsMissionsInQueueEmpty = createSelector(
  getMissionsInQueue,
  getMissionsInQueueStatus,
  (missionsQueue, status) =>
    missionsQueue.length === 0 && status === DataStatus.succeeded
);
